// extracted by mini-css-extract-plugin
export default {"imageWrapper":"broadcasterLogo_imageWrapper__orhiG"};